export const getIsOverdue = (balanceDue: number | null | undefined): boolean => {
  // Ported from web: amount > 100 and day of month between 3 and 25
  const value = Number(balanceDue || 0);
  if (!Number.isFinite(value)) return false;
  const today = new Date();
  const day = today.getDate();
  return value > 100 && day >= 3 && day <= 25;
};

export const getInCredit = (balanceDue: number | null | undefined): boolean => {
  const value = Number(balanceDue || 0);
  return Number.isFinite(value) && value < 0;
};

export const mapLeaseStatus = (status?: string): string => {
  switch ((status || '').toLowerCase()) {
    case 'current':
      return 'Current Lease';
    case 'past':
      return 'Past Lease';
    case 'future':
      return 'Future Lease';
    case 'notice':
      return 'Lease On Notice';
    default:
      return '';
  }
};


